export const UserRole = {
  ADMIN: 'ADMIN',
  SUPERADMIN: 'SUPERADMIN',
  WHATSAPP: 'WHATSAPP',
} as const;

export const ROLES_WITH_WHATSAPP_ACCESS: readonly string[] = [
  UserRole.SUPERADMIN,
  UserRole.ADMIN,
  UserRole.WHATSAPP,
];

export const ROLES_WITH_DASHBOARD_ACCESS: readonly string[] = [
  UserRole.SUPERADMIN,
  UserRole.ADMIN,
];

export const SUPERADMIN_ONLY_ROLES: readonly string[] = [UserRole.SUPERADMIN];

export const ASSIGNABLE_ROLES: readonly string[] = [
  UserRole.ADMIN,
  UserRole.WHATSAPP,
];

export const ROLE_NAMES: Record<string, string> = {
  [UserRole.SUPERADMIN]: 'Super Admin',
  [UserRole.ADMIN]: 'Admin',
  [UserRole.WHATSAPP]: 'WhatsApp',
};
